import React from "react";
import { Box, Paper, Typography } from 'convertupleads-theme';
import BashEditor from "../common/BashEditor";

const EachSection = ({ title = "", children }) => (
    <Box sx={{ marginBottom: "40px" }}>
        <Typography
            variant={"h4"}
            color={"text.primary"}
            sx={{ marginBottom: "15px" }}
        >
            {title}
        </Typography>
        {children}
    </Box>
);

const Dashboard = ({ children }) => {
    return (
        <>
            <Paper elevation={0} sx={{ p: 3 }}>
                <Typography variant={"h3"} color={"text.primary"}>
                    WelCome to{" "}
                </Typography>
                <Typography variant={"h3"} color={"success.main"}>
                    Style Guide Documentation
                </Typography>
            </Paper>

            <Paper elevation={0} sx={{ p: 3 }}>
                <EachSection title="Overview">
                    This is a style guide documentation for{" "}
                    <a href="https://www.npmjs.com/package/convertupleads-theme?activeTab=readme">
                        ConvertUpLeads
                    </a>
                    , a tool that contains all components for the project.
                </EachSection>
                <EachSection title="Installation">
                    To use this theme, you need to have
                    <a href="https://www.npmjs.com/package/convertupleads-theme?activeTab=readme">
                        ConvertUpLeads
                    </a>{" "}
                    installed on your machine. You can install it with npm:
                    <BashEditor code="npm install convertupleads-theme" language="npm" />
                    or
                    <BashEditor code="yarn add convertupleads-theme" language="npm" />
                </EachSection>
                <EachSection title="Primary Setup">
                    You need to use the{" "}
                    <b>
                        <i>ThemeProvider</i>
                    </b>{" "}
                    component in order to inject our theme into your application.
                    <BashEditor
                        code={`import { ThemeProvider } from "convertupleads-theme";\n\nexport default function App() {\n  <ThemeProvider>\n    {/* Childrens here */}\n  </ThemeProvider>\n}`}
                        language="js"
                    />
                </EachSection>
            </Paper>
        </>
    );
};

export default Dashboard;
